import { PipeTransform, Pipe } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'wazeLink',
})
export class WazeLinkPipe implements PipeTransform {
  transform(
    line1: string,
    city: string,
    postalCode: string,
    country?: string,
    lat?: number,
    lng?: number
  ) {
    return encodeURI(
      `https://waze.com/ul?q=${StringHelper.join(
        [line1, StringHelper.join([city, postalCode], ' '), country],
        ', '
      )}+'&ll=${StringHelper.join([String(lat), String(lng)], ',')}`
    );
  }
}
